module.exports = __webpack_public_path__ + "static/fonts/iconfont.d1095ed.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/sass/fonts/iconfont.ttf?t=1572604158982
// module id = K3ky
// module chunks = 33 34 35 36 37